import { Download } from "lucide-react";
import { downloadCsv } from "@/lib/csv";

export const Locality = ({ data, period }) => {
  const exportCsv = () => downloadCsv(`localidades_${period}.csv`, ["Estado", "Cidade", "Participantes"],
    data.flatMap((s) => s.cities.map((c) => [s.state, c.city, c.count])));
  return (
    <section className="space-y-4">
      <div className="flex items-center justify-between gap-3">
        <p className="text-sm text-muted-foreground">Somente cidade e estado informados no cadastro. Nenhuma localização por GPS.</p>
        <button data-testid="locality-export" onClick={exportCsv} disabled={!data.length}
          className="flex h-9 shrink-0 items-center gap-1.5 rounded-md bg-zap-deep px-3 text-sm font-medium text-white disabled:opacity-50">
          <Download className="h-4 w-4" />Planilha
        </button>
      </div>
      {data.length === 0 ? <p className="text-sm text-muted-foreground">Nenhum participante no período.</p> : (
        <div data-testid="locality-list" className="grid gap-4 md:grid-cols-2">
          {data.map((s) => (
            <div key={s.state} data-testid={`locality-state-${s.state}`} className="rounded-md border border-zap-line">
              <div className="flex items-center justify-between bg-zap-mist px-3 py-2">
                <span className="font-display font-semibold">{s.state}</span>
                <span className="text-sm font-semibold tabular-nums">{s.total} {s.total === 1 ? "participante" : "participantes"}</span>
              </div>
              <ul className="divide-y divide-zap-line text-sm">
                {s.cities.map((c) => (
                  <li key={c.city} className="flex justify-between px-3 py-1.5"><span>{c.city}</span><span className="tabular-nums">{c.count}</span></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
